import EmailIcon from '@mui/icons-material/Drafts';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useCallback, useState } from 'react';

import { MemberEmailForm } from 'components';
import Loader from 'components/Loader';
import { useAddMemberNotificationMutation, useCreateEmailCarbonCopyMutation } from 'store/api/version-api.slice';

import ModalTestEmail from './ModalTestEmail';
import { styles } from './styles';

const AddNotificationEmailDialog = ({ dialogs, handleDialogClose }) => {
	const [toggleTestEmail, setToggleTestEmail] = useState(false);

	const [editEmailForm, setEditEmailForm] = useState({
		email_type: '',
		email_subject: '',
		frequency: 90,
		email_body: '',
		memberemailformcc_set: []
	});

	const [addMemberNotification, { isLoading: isAddLoading }] = useAddMemberNotificationMutation();

	const [createEmailCC, { isLoading: isCreateLoading }] = useCreateEmailCarbonCopyMutation();

	const handleToggleTestEmail = () => {
		setToggleTestEmail(prev => !prev);
	};

	const handleEditFormValueChange = useCallback((prop, value) => {
		setEditEmailForm(prev => ({
			...prev,
			[prop]: value
		}));
	}, []);

	const handleAddEmail = async () => {
		const { memberemailformcc_set = [], ...rest } = editEmailForm;
		const response = await addMemberNotification(rest);

		const createPromises = memberemailformcc_set.map(cc => {
			return createEmailCC({
				...cc,
				member_email_form: response.data?.id
			});
		});

		await Promise.allSettled(createPromises);

		handleDialogClose();
	};

	const isLoading = isAddLoading || isCreateLoading;

	return (
		<Dialog
			TransitionProps={{ tabIndex: '' }}
			open={dialogs.add}
			onClose={handleDialogClose}
			maxWidth={'md'}
			fullWidth={true}
		>
			<DialogTitle>Add Notification Email</DialogTitle>
			<DialogContent sx={styles.dialogContent}>
				{isLoading && <Loader />}
				<MemberEmailForm
					email_type={editEmailForm.email_type}
					email_body={editEmailForm.email_body}
					frequency={editEmailForm.frequency}
					email_subject={editEmailForm.email_subject}
					memberemailformcc_set={editEmailForm.memberemailformcc_set}
					handleChange={handleEditFormValueChange}
				/>
			</DialogContent>
			<DialogActions sx={styles.dialogActions}>
				<Button sx={styles.btnTestEmail} onClick={handleToggleTestEmail} color="primary">
					<EmailIcon sx={styles.iconOffset} /> Test Email
				</Button>
				<Box>
					<Button sx={styles.actionButtons} onClick={handleDialogClose} color="secondary">
						Cancel
					</Button>
					<Button
						sx={{
							...styles.actionButtons,
							...styles.saveBtn
						}}
						onClick={handleAddEmail}
						variant="contained"
						color="primary"
						disabled={isLoading}
						startIcon={<SaveIcon sx={styles.iconOffset} />}
					>
						Save
					</Button>
				</Box>
			</DialogActions>
			{toggleTestEmail && <ModalTestEmail handleClose={handleToggleTestEmail} data={editEmailForm} />}
		</Dialog>
	);
};

export default AddNotificationEmailDialog;
